import { language as lan_uploadFileModal } from "./upload-file-modal";

let language = {
    // 图片上传模态框
    ...lan_uploadFileModal,
    STORE_PRODUCT_SETTING_MOCKUP_MAIN_MOCKUP: "主模型",
    STORE_PRODUCT_SETTING_MOCKUP_LIST_TITLE: "所有产品图片",
    STORE_PRODUCT_SETTING_MOCKUP_UPLOAD_RULE: "您可以添加最多 10 张图片，这些图片将作为您店铺中产品的备用视图展示。每张图片必须小于 500kb，最大为 2,000 x 2,000 像素。支持的图片格式有 JPG、JPEG、PNG 和 GIF。",
    STORE_PRODUCT_SETTING_MOCKUP_IMAGE_ERROR_TIP: "您的产品模型缩略图加载失败，请点击重新加载图片。",
    STORE_PRODUCT_SETTING_MOCKUP_IMAGE_FORMAT: "图片格式",
    STORE_PRODUCT_SETTING_MOCKUP_IMAGE_FORMAT_JPG: "JPG",
    STORE_PRODUCT_SETTING_MOCKUP_IMAGE_FORMAT_JPG_DES: "(文件大小较小 - 您的店铺加载更快。)",
    STORE_PRODUCT_SETTING_MOCKUP_IMAGE_FORMAT_PNG: "PNG",
    STORE_PRODUCT_SETTING_MOCKUP_IMAGE_FORMAT_PNG_DES: "(文件大小较大 - 支持透明背景。)",
    STORE_PRODUCT_SETTING_MOCKUP_MOCKUP_PREVIEW: "模型预览",
    STORE_PRODUCT_SETTING_MOCKUP_EMPTY_IMAGE_TIP: "产品模型不能为空，请上传您的产品图片。",
    STORE_PRODUCT_SETTING_MOCKUP_ATY_VERIFY_TIP: "最大允许上传 10 张产品图片。请在添加新图片之前选择更新或删除现有图片。",
    // 删除产品图片，提示信息
    STORE_PRODUCT_SETTING_MOCKUP_DELETE_IMAGE_TITLE: "删除图片！",
    STORE_PRODUCT_SETTING_MOCKUP_DELETE_IMAGE_DES: "您确定要删除这张图片吗？",
    STORE_PRODUCT_SETTING_MOCKUP_DELETE_IMAGE_SUCCESS: "删除成功！",
    STORE_PRODUCT_SETTING_MOCKUP_DELETE_IMAGE_OK_BTN: "确定",
    STORE_PRODUCT_SETTING_MOCKUP_DELETE_IMAGE_CANCEL_BTN: "取消",
    // 店铺产品图片为空提示
    STORE_PRODUCT_SETTING_MOCKUP_EMPTY_IMAGE_TITLE: "产品模型为空",
    // 产品图片数量小于等于1，禁止删除图片提示信息
    STORE_PRODUCT_SETTING_MOCKUP_DELETE_DISABLE_TITLE: "删除图片！",
    STORE_PRODUCT_SETTING_MOCKUP_DELETE_DISABLE_DES: "抱歉，产品图片不能全部删除。",
    // 图片上传图片数量校验提示
    STORE_PRODUCT_SETTING_MOCKUP_CONFIRM_UPLOAD_QTY_TITLE: "确认上传",
    STORE_PRODUCT_SETTING_MOCKUP_CONFIRM_UPLOAD_DES: "您尝试上传了 {{uploadQty}} 张图片，我们只能上传 {{allowUploadQty}} 张。请重新选择图片。",
    // 店铺产品图片数量校验提示
    STORE_PRODUCT_SETTING_MOCKUP_ATY_VERIFY_TITLE: "产品模型数量",
    STORE_PRODUCT_SETTING_MOCKUP_ATY_VERIFY_DES: "抱歉，您当前的产品模型数量为 {{mockupsQty}}。允许添加的店铺产品图片数量范围为 {{minMockupQty}} 到 {{maxMockupQty}}。",
    // 店铺产品图片生成中提示
    STORE_PRODUCT_SETTING_MOCKUP_MOCKUP_RUNNING_TITLE: "模型图片生成中",
    STORE_PRODUCT_SETTING_MOCKUP_MOCKUP_RUNNING_DES: "抱歉，产品渲染尚未完成，请点击 [{{buttonText}}] 稍后重试。",
    STORE_PRODUCT_SETTING_MOCKUP_NAME_RULE_TIP: "名称长度 {{rangeLength}}",
    // mockup图片生成失败
    STORE_PRODUCT_SETTING_MOCKUP_FAILED_TIP: "模型图片生成失败，请点击重试。",
    // mockup图片生成中
    STORE_PRODUCT_SETTING_MOCKUP_RUNNING_TIP: "模型图片正在生成中，请耐心等待并点击重试。",
};

export { language };
